import React, { Component } from 'react';
import ServiceProviderPermissions from './serviceProviderPermissions';

export default class PermissionItemContainer extends Component {

    render() {
  
        const { data } = this.props;

        return (
            <div>
                {
                    data.map(item => {

                        return <div
                                    key={item.id}
                                >
                                    <ServiceProviderPermissions
                                        data={item}
                                    />
                                </div>;
                    })
                }
            </div>
        );
    }
}
